(function () {
  const pathname = window.location.pathname;
  const search = window.location.search;
  const hash = window.location.hash;

  const AUTH_PATH_PREFIXES = ['/account', '/en/account', '/de/account', '/customer_authentication', '/authentication'];

  const AUTH_QUERY_KEYS = [
    'return_url',
    'redirect_uri',
    'code',
    'state',
    'token',
    'id_token',
    'login_hint',
    'analytics_trace_id',
  ];

  const isAuthRoute = () => {
    if (pathname.includes('/challenge') || pathname.includes('/password')) {
      return true;
    }

    if (AUTH_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix))) {
      return true;
    }

    if (!search) {
      return false;
    }

    const params = new URLSearchParams(search);
    return AUTH_QUERY_KEYS.some((key) => params.has(key));
  };

  // Never rewrite URLs during login, OAuth, or Shop Pay auth handoffs.
  if (isAuthRoute()) {
    return;
  }

  const userLang = navigator.language || navigator.userLanguage;
  const preferredLang = localStorage.getItem('preferredLang');

  const stripLocalePrefix = (path) => {
    if (path.startsWith('/en/')) return path.slice(3) || '/';
    if (path === '/en') return '/';
    if (path.startsWith('/de/')) return path.slice(3) || '/';
    if (path === '/de') return '/';
    return path;
  };

  const withQuery = (path) => `${path}${search}${hash}`;
  const currentPath = stripLocalePrefix(pathname);

  if (!preferredLang || preferredLang !== userLang) {
    if (userLang.startsWith('de')) {
      if (pathname !== currentPath) {
        window.location.href = withQuery(currentPath);
        return;
      }
    } else if (userLang.startsWith('en')) {
      if (!pathname.startsWith('/en')) {
        window.location.href = withQuery(`/en${currentPath}`);
        return;
      }
    } else if (pathname.startsWith('/en')) {
      window.location.href = withQuery(currentPath);
      return;
    }

    localStorage.setItem('preferredLang', userLang);
  }
})();
